/**
 * @file src/js/models/linearchannels.js
 * @description Channel model
 * @author Josef Jurca <josef.jurca@24imedia.com>
 */

class LinearChannels {

    /**
     * Constructs the model.
     *
     * @param {Object} data - Data object.
     */
    constructor (data) {
        this.channels = data.channels || [];
        this.objectType = data.objectType || '';
        this.totalCount = data.totalCount || 0;
    }

    /**
     * Returns all active channels array.
     *
     * @returns {Array} Assets array.
     */
    getChannels () {
        return this.channels;
    }

    /**
     * Returns channels count.
     *
     * @returns {number} Assets count.
     */
    getChannelsCount () {
        return this.totalCount;
    }
}

export default LinearChannels;


// WEBPACK FOOTER //
// ./src/js/models/linearchannels.js